"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROLES_LIST = exports.USER_ROLE_GROUPS = exports.USER_ROLES = void 0;
exports.USER_ROLES = {
    ENGAGEMENT_LEAD: 'Engagement Lead',
    ENGAGEMENT_MANAGER: 'Engagement Manager',
    PROJECT_ADMIN: 'Project Admin',
    APPROVER: 'Approver',
    TEAM_MEMBER: 'Team Member',
    PWC_READONLY: 'PwC Readonly',
    PWC_READONLY_DISPLAY: 'Read-only user',
    CLIENT_ADMIN: 'Client Admin',
    CLIENT_TEAM_MEMBER: 'Client Team Member',
};
exports.USER_ROLE_GROUPS = {
    INTERNAL: [
        exports.USER_ROLES.ENGAGEMENT_LEAD,
        exports.USER_ROLES.ENGAGEMENT_MANAGER,
        exports.USER_ROLES.PROJECT_ADMIN,
        exports.USER_ROLES.APPROVER,
        exports.USER_ROLES.TEAM_MEMBER,
        exports.USER_ROLES.PWC_READONLY,
    ],
    INTERNAL_READWRITE: [
        exports.USER_ROLES.ENGAGEMENT_LEAD,
        exports.USER_ROLES.ENGAGEMENT_MANAGER,
        exports.USER_ROLES.PROJECT_ADMIN,
        exports.USER_ROLES.APPROVER,
        exports.USER_ROLES.TEAM_MEMBER,
    ],
    CLIENT: [exports.USER_ROLES.CLIENT_ADMIN, exports.USER_ROLES.CLIENT_TEAM_MEMBER],
};
exports.USER_ROLES_LIST = Object.values(exports.USER_ROLES);
